var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom-panel"},[_c('div',{staticClass:"border-bolder"},[_c('div',{staticClass:"border-lighter"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"default"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }